import { environment } from "src/environments/environment";
import * as CryptoJS from "crypto-js";
import SecureStorage from "secure-web-storage";

export class SessionStorageService {
  public static secureStorage = new SecureStorage(sessionStorage, {
    hash: (key:any) => {
      key = CryptoJS.HmacSHA256(key, environment.SECRET_KEY);

      return key.toString();
    },
    encrypt: (data:any) => {
      data = CryptoJS.AES.encrypt(data, environment.SECRET_KEY);
      data = data.toString();
      return data;
    },
    decrypt: (data:any) => {
      data = CryptoJS.AES.decrypt(data, environment.SECRET_KEY);
      data = data.toString(CryptoJS.enc.Utf8);
      return data;
    },
  });

  public static getValue(key: any) {
    return this.secureStorage.getItem(key);
  }

  public static removeValue(key: any) {
    this.secureStorage.removeItem(key);
  }

  public static setValue(key: any, value: any) {
    this.secureStorage.setItem(key, value);
  }

  public static clearSessionStorage() {
    this.secureStorage.clear();
  }
}
